import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showArchiveButton)?_c(VBtn,{attrs:{"disabled":_vm.loading || _vm.isDisabled,"large":""},on:{"click":_vm.archiveConfirmThenEmitAction}},[_c('archive-icon'),_c('span',[_vm._v(_vm._s(_vm.$t("WorkspaceEdit.archive.buttonLabel")))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }